import client from "../client";
import { DocumentTemplateInterface } from "../../models/ProcurementModule/DocumentTemplate";

const listName = "DocumentTemplates";
class DocumentTemplateService {
  async GetAll(page: number, pageSize: number) {
    try {
      const { data } = await client.post<DocumentTemplateInterface[]>(
        `/api/${listName}/get`,
        {
          page,
          pageSize,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GenerateTemplate(id: string) {
    try {
      const { data } = await client.post<string>(
        `/api/${listName}/GenerateDocument/${id}`,
        { url: "" }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<DocumentTemplateInterface>(
        `/api/${listName}/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(item: DocumentTemplateInterface) {
    try {
      const { data } = await client.post<DocumentTemplateInterface>(
        `/api/${listName}/Add`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, item: DocumentTemplateInterface) {
    try {
      const { data } = await client.post<DocumentTemplateInterface>(
        `/api/${listName}/update/${id}`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<DocumentTemplateInterface>(
        `/api/${listName}/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetSchema(
    template:
      | "RequestForQuotationModule"
      | "RequestForProposalModule"
      | "PurchaseRequestModule"
      | "PurchaseOrderModule"
  ) {
    try {
      const { data } = await client.post<string[]>(
        `/api/${template}/getSchema`,
        { url: "" }
      );
      return data ?? [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetPOSchema() {
    try {
      const { data } = await client.post<string[]>(
        `/api/PurchaseOrders/getSchema`,
        { url: "" }
      );
      return data ?? [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetDocumentTypes() {
    try {
      const { data } = await client.get<string[]>(
        `/api/${listName}/GetDocumentTypes`
      );
      return data ?? [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GenerateDocument(
    list:
      | "RequestForProposalModule"
      | "PurchaseRequestModule"
      | "RequestForQuotationModule",
    id: string
  ) {
    try {
      const { data } = await client.post<any>(
        `api/${list}/GenerateDocument/${id}`
      );
      return data ?? [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new DocumentTemplateService();
